import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomeForm from "./components/HomeForm";
import SobreNosotrosForm from "./components/SobreNosotrosForm";
import ContactenosForm from "./components/ContactenosForm";
import ServiciosForm from "./components/ServiciosForm";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import MarcaForm from "./components/MarcaForm";
import Dashboard from "./pages/Dashboard";
import Pago from "./components/Pago";
import EnergiaAlDia from "./components/EnergiaAlDiaForm";
import NuestroPortafolio from "./components/NuestroPortafolioForm";
import InformacionGratuita from "./components/InformacionGratuitaForm";

const App = () => {
  const [token, setToken] = useState(() => localStorage.getItem("token"));

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeForm />} />

        {/* Login: solo si NO hay token */}
        <Route
          path="/login"
          element={!token ? <LoginForm setToken={setToken} /> : <Navigate to="/dashboard" replace />}
        />

        <Route path="/register" element={<RegisterForm />} />
        <Route path="/sobrenosotros" element={<SobreNosotrosForm />} />
        <Route path="/servicios" element={<ServiciosForm />} />
        <Route path="/contactenos" element={<ContactenosForm />} />
        <Route path="/pago" element={<Pago />} />
        <Route path="/noticias" element={<EnergiaAlDia />} />
        <Route path="/nuestroportafolio" element={<NuestroPortafolio />} />
        <Route path="/informaciongratuita" element={<InformacionGratuita />} />
        

        {/* Protegidas */}
        <Route
          path="/dashboard"
          element={token ? <Dashboard setToken={setToken} /> : <Navigate to="/login" replace />}
        />
        
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
